import {$dom} from '../../../../helpers/dom';
import gsap from 'gsap';
import variables from '../../../../variables';
import vars from './vars';

const {
	exist,
	get
} = $dom;

const {
	paginationSelector
} = vars;

export default function catalogStickyPagination() {
	if (exist(paginationSelector)) {

		const {
			footer
		} = variables.dom;

		let pagination, tl;

		const
			init = () => {

				pagination = get(paginationSelector);

				const
					footerHeight = footer.offsetHeight,
					paginationHeight = pagination.offsetHeight
				;

				tl = gsap.timeline();

				tl.to(pagination, {
					bottom: (footerHeight - paginationHeight) + 'px',
					ease: 'linear',
					scrollTrigger: {
						trigger: footer,
						start: `top+=${paginationHeight} bottom`,
						end: `+=${footerHeight - paginationHeight}`,
						scrub: true,
					}
				});

			},
			destroy = () => {
				tl.kill();
				tl = null;
			}
		;

		return {init, destroy}
	}

}
